export const CONFIGURATION_REQUEST = "CONFIGURATION_REQUEST";
export const CONFIGURATION_SUCCESS = "CONFIGURATION_SUCCESS";
export const CONFIGURATION_FAILURE = "CONFIGURATION_FAILURE";

export const GET_CONFIGURATION_REQUEST = "GET_CONFIGURATION_REQUEST";
export const GET_CONFIGURATION_SUCCESS = "GET_CONFIGURATION_SUCCESS";
export const GET_CONFIGURATION_FAILURE = "GET_CONFIGURATION_FAILURE";